import React from 'react';
import VspRow from './VspRow.js';

function VspTable({ vsp, onEdit, onDelete, msg = '', canEdit = false  }) {
  const rows = Array.isArray(vsp) ? vsp : [];

  return (
    <table id="vsps">
      <caption className='caption_text'>
        Vspeed table
        {msg ? ` — ${msg}` : ''}
      </caption>

      <thead>
        <tr>
          <th className='name_box'>Name</th>
          <th className='config_box'>Configuration</th>
          <th className='speed_box'>Vspeed1</th>
          <th className='speed_box'>Vspeed2</th>
          <th className='unit_box'>Units</th>

          { canEdit && (
            <>
          <th className='edit_box'>Edit</th>
          <th className='delete_box'>Delete</th>
          </>
          )}
        </tr>
      </thead>

      <tbody>
        {rows.map((item, i) => (
          <VspRow
            key={item.id ?? item._id ?? i}
            vsp={item}
            onEdit={onEdit}
            onDelete={onDelete}
            canEdit={canEdit}
          />
        ))}
      </tbody>
    </table>
  );
}

export default VspTable;